// extracted by mini-css-extract-plugin
export var button = "annualReport-module--button--3bf8e";
export var buttonMobile = "annualReport-module--buttonMobile--c2fee";
export var image = "annualReport-module--image--75390";
export var imageContainer = "annualReport-module--imageContainer--dac61";
export var report = "annualReport-module--report--283ba";
export var slides = "annualReport-module--slides--69027";
export var textContainer = "annualReport-module--textContainer--b8504";